module.exports = __webpack_public_path__ + "img/drive-background.e9cac7ba.jpg";